import { render, staticRenderFns } from "./LayoutCustomers.vue?vue&type=template&id=77f84a32&scoped=true"
import script from "./LayoutCustomers.vue?vue&type=script&lang=js"
export * from "./LayoutCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f84a32",
  null
  
)

export default component.exports